import React, { useState, useEffect } from 'react'
import Popup from '../../Popup/Popup'
import Success from '../../Success/Success'
import Axios from '../../Axios/Axios'
import ColumnRecord from '../../CreateExerciseWizard/components/ColumnRecord'
import Spinner from '../../Spinner/Spinner'

function EditColumnOrder(props) {
    const [loading, setLoading] = useState(true)
    const [columns, setColumns] = useState({})
    const [order, setOrder] = useState([])
    const [dragged, setDragged] = useState(-1)
    const [dropped, setDropped] = useState(-1)
    const [success, setSuccess] = useState()

    useEffect(() => {
        Axios(props.endpoints.getExercise, { id: props.data.ID }, (data) => {
            const raw = data?.[0]?.COLUMNS
            if (raw) {
                const parsed = JSON.parse(raw)
                setColumns(parsed)
                // Sort keys numerically to get initial order
                setOrder(Object.keys(parsed).sort((a, b) => parseInt(a) - parseInt(b)))
            }
            setLoading(false)
        })
    }, [])

    // Swap two entries in order when a drag-drop completes
    useEffect(() => {
        if (dragged !== -1 && dropped !== -1) {
            setOrder(prev => {
                const next = [...prev]
                const temp = next[dropped]
                next[dropped] = next[dragged]
                next[dragged] = temp
                return next
            })
            setDragged(dropped)
        }
    }, [dragged, dropped])

    const submit = () => {
        // Rebuild columns object with sequential integer keys in the new order
        const newConfig = {}
        order.forEach((oldKey, newIndex) => {
            newConfig[newIndex] = columns[oldKey]
        })

        Axios(props.endpoints.editExerciseWidth, { id: props.data.ID, config: newConfig }, (data) => {
            if (props.setData) props.setData(data)
            setSuccess(true)
        }, () => {
            setSuccess(false)
        })
    }

    if (success !== undefined) {
        return <Success {...props} success={success} successMessage={"Column order updated successfully."} />
    }

    const body = loading ? <Spinner /> : (
        <div className={"pop-body"} style={{ alignItems: 'stretch' }}>
            <div style={{ fontSize: 12, color: '#555', marginBottom: 8 }}>
                Drag and drop the columns below to set their display order.
            </div>
            <div style={{ maxHeight: '60vh', overflowY: 'auto', padding: '0 4px' }}>
                {order.map((key, i) => (
                    <div key={key} style={{ display: 'flex', width: '100%' }}>
                        <ColumnRecord
                            order={i}
                            data={columns[key]}
                            setDragged={setDragged}
                            setDropped={setDropped}
                        />
                    </div>
                ))}
            </div>
            <div className={"pop-buttonRow"}>
                <button type="button" id={"pop-cancel"} onClick={props.close}>CANCEL</button>
                <button id={"pop-submit"} onClick={submit}>SAVE ORDER</button>
            </div>
        </div>
    )

    return <Popup {...props} body={body} title={"Edit Column Order"} />
}

export default EditColumnOrder
